/* IceCartel chain / bracelet / bundle weight.
   The Weight column is grams per inch (or a width→rate list), not the weight
   of the longest size. Rings, earrings, and pendants are left to the old
   proportional formula in VariantHandling._updateMetafields. */
(function (root) {
  var CHAIN_LENGTH_NAMES = {
    'size': true,
    'length': true,
    'chain size': true,
    'necklace size': true,
    'cuban chain size': true,
    'tennis chain size': true
  };

  function normalizeName(name) {
    return String(name == null ? '' : name).trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function normalizeTags(tags) {
    var list = [];
    if (Array.isArray(tags)) list = tags;
    else if (typeof tags === 'string') list = tags.split(',');
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var tag = String(list[i] == null ? '' : list[i]).trim().toLowerCase();
      if (tag) out.push(tag);
    }
    return out;
  }

  function hasExactTag(tags, name) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i] === name) return true;
    }
    return false;
  }

  /* One inch token: 18", 7", 18 inches, 26" (3 Weeks Production).
     Two lengths in one value (20" + 22") are not a length. */
  function parseInches(value) {
    if (value == null) return null;
    var text = String(value);
    var re = /(\d+(?:\.\d+)?)\s*(?:["″”]|inches?\b)/gi;
    var found = [];
    var match;
    while ((match = re.exec(text))) {
      found.push(parseFloat(match[1]));
    }
    if (found.length !== 1 || !isFinite(found[0])) return null;
    return found[0];
  }

  /* Stone Size, Width, Link Width, Chain Width, and Ring Size are never lengths.
     Bracelet options are any name containing "bracelet". */
  function lengthRole(name) {
    var n = normalizeName(name);
    if (!n) return null;
    if (n === 'stone size' || n === 'width' || n === 'link width' || n === 'chain width') return null;
    if (n === 'ring' || n.indexOf('ring size') !== -1 || n.indexOf('ring ') === 0) return null;
    if (n.indexOf('bracelet') !== -1) return 'bracelet';
    if (CHAIN_LENGTH_NAMES[n]) return 'chain';
    return null;
  }

  function collectLengths(optionNames, optionValues) {
    var chain = [];
    var bracelet = [];
    var count = Math.max(optionNames.length, optionValues.length);
    for (var i = 0; i < count; i++) {
      var role = lengthRole(optionNames[i]);
      if (!role) continue;
      var inches = parseInches(optionValues[i]);
      if (inches == null) continue;
      if (role === 'bracelet') bracelet.push(inches);
      else chain.push(inches);
    }
    return { chain: chain, bracelet: bracelet };
  }

  function selectedInches(flags, optionNames, optionValues) {
    var lengths = collectLengths(optionNames, optionValues);
    var parts;
    if (flags.isBundle) {
      parts = lengths.chain.concat(lengths.bracelet);
      if (!parts.length) return null;
      var sum = 0;
      for (var i = 0; i < parts.length; i++) sum += parts[i];
      return sum;
    }
    if (flags.isBracelet && !flags.isChain) {
      parts = lengths.bracelet.length ? lengths.bracelet : lengths.chain;
      return parts.length ? parts[0] : null;
    }
    if (lengths.chain.length) return lengths.chain[0];
    if (lengths.bracelet.length) return lengths.bracelet[0];
    return null;
  }

  function parseWidthList(weightText) {
    var text = String(weightText == null ? '' : weightText);
    if (!/mm/i.test(text)) return null;
    var re = /(\d+(?:\.\d+)?)\s*mm\s*[:\-–—/]?\s*(\d+(?:\.\d+)?)/gi;
    var entries = [];
    var match;
    while ((match = re.exec(text))) {
      entries.push({ width: parseFloat(match[1]), rate: parseFloat(match[2]) });
    }
    return entries.length ? entries : null;
  }

  function parseSingleNumber(value) {
    if (typeof value === 'number') return isFinite(value) ? value : null;
    if (value == null) return null;
    var text = String(value).trim();
    if (!text || /mm/i.test(text)) return null;
    var numbers = text.match(/\d+(?:\.\d+)?/g);
    if (!numbers || numbers.length !== 1) return null;
    var n = parseFloat(numbers[0]);
    return isFinite(n) ? n : null;
  }

  function selectedWidth(optionNames, optionValues) {
    var preferred = [];
    var other = [];
    var count = Math.max(optionNames.length, optionValues.length);
    for (var i = 0; i < count; i++) {
      var raw = optionValues[i];
      if (raw == null) continue;
      var match = String(raw).match(/(\d+(?:\.\d+)?)\s*mm\b/i);
      if (!match) continue;
      // An inch length such as 18" is not a width, even if the name is Size.
      if (parseInches(raw) != null) continue;
      var width = parseFloat(match[1]);
      var name = normalizeName(optionNames[i]);
      if (
        name === 'stone size' ||
        name === 'width' ||
        name === 'link width' ||
        name === 'chain width' ||
        name.indexOf('stone') !== -1
      ) {
        preferred.push(width);
      } else {
        other.push(width);
      }
    }
    return preferred.concat(other);
  }

  function rateForWidth(entries, optionNames, optionValues) {
    var widths = selectedWidth(optionNames, optionValues);
    for (var i = 0; i < widths.length; i++) {
      for (var j = 0; j < entries.length; j++) {
        if (Math.abs(entries[j].width - widths[i]) < 0.001) return entries[j].rate;
      }
    }
    return null;
  }

  /* weight / weight_per_inch in [14, 36] means weight is the finished total
     at that many inches, and weight_per_inch is the grams-per-inch rate. */
  function resolveRate(weight, weightPerInch, optionNames, optionValues) {
    var list = parseWidthList(weight);
    if (list) return rateForWidth(list, optionNames, optionValues);

    var weightNumber = parseSingleNumber(weight);
    if (weightNumber == null) return null;
    var perInch = parseSingleNumber(weightPerInch);
    if (perInch != null && perInch !== 0) {
      var ratio = weightNumber / perInch;
      if (ratio >= 14 - 1e-6 && ratio <= 36 + 1e-6) return perInch;
    }
    return weightNumber;
  }

  function formatGrams(total) {
    var tenths = Math.round(Math.abs(total) * 10 + 1e-8);
    var text = (tenths / 10).toFixed(1);
    return (total < 0 ? '-' : '') + text + 'g';
  }

  function computeDisplay(input) {
    var src = input || {};
    var tags = normalizeTags(src.tags);
    var flags = {
      isChain: hasExactTag(tags, 'chains'),
      isBracelet: hasExactTag(tags, 'bracelets'),
      isBundle: hasExactTag(tags, 'bundles')
    };
    if (!flags.isChain && !flags.isBracelet && !flags.isBundle) {
      return { applies: false };
    }

    var optionNames = src.optionNames || [];
    var optionValues = src.optionValues || [];
    var inches = selectedInches(flags, optionNames, optionValues);
    var rate = resolveRate(src.weight, src.weightPerInch, optionNames, optionValues);
    if (inches == null || rate == null) {
      return { applies: true, display: null, hideWeightPerInch: false };
    }

    return {
      applies: true,
      display: formatGrams(rate * inches),
      hideWeightPerInch: true
    };
  }

  var api = { computeDisplay: computeDisplay };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.IceChainWeight = api;
})(typeof window !== 'undefined' ? window : globalThis);
